import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { connect } from "react-redux";
import { fetch_stats } from "../../redux/actions/adminActions";
import Dropdown from "../reusables/dropdown";
import { animationValues, transitionValues } from "../../utils/pageTransitions";
import { periods } from "../../utils/options";
import Spinner from "../reusables/spinner";

function Dashboard({ adminStats, fetchData, accessToken }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchData(accessToken, () => setLoading(false));
  }, [fetchData, accessToken]);

  const [selectedTime, setTime] = useState("All dates");

  const handleSelect = (Item) => {
    setTime(Item);
    setLoading(true);
    fetchData(accessToken, () => setLoading(false), Item);
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="container-fluid">
        <Dropdown value={selectedTime}>
          {periods?.map((item) => (
            <div
              className="isClickable hoverGreen"
              onClick={() => handleSelect(item)}
            >
              <p className="sectionText px-3 py-2 mb-0">{item}</p>
            </div>
          ))}
        </Dropdown>
        {!loading ? (
          <div className="row">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-md-4 col-6 mt-3">
                  <div className="hasRadius bgGreen center stats__card">
                    <div className="">
                      <p className="sectionText--small textIsGreen mb-1">
                        Total Earnings
                      </p>
                      <h2 className="sectionText--big textIsGreen textIsBold">
                        ₦ {adminStats?.total_earnings}
                      </h2>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 col-6 mt-3">
                  <div className="hasBorder hasRadius center stats__card">
                    <div className="">
                      <p className="sectionText--small textIsGray mb-1">
                        Total Orders
                      </p>
                      <h2 className="sectionText--big textIsBold">
                        {adminStats?.total_orders}
                      </h2>
                    </div>
                  </div>
                </div>

                <div className="col-md-4  col-6 mt-3">
                  <div className="hasBorder hasRadius center stats__card">
                    <div className="">
                      <p className="sectionText--small textIsGray mb-1">
                        Accepted Orders
                      </p>
                      <h2 className="sectionText--big  textIsBold">
                        {adminStats?.accepted_orders}
                      </h2>
                    </div>
                  </div>
                </div>

                <div className="col-md-4  col-6 mt-3">
                  <div className="hasBorder hasRadius center stats__card">
                    <div className="">
                      <p className="sectionText--small textIsGray mb-0">
                        Declined Orders
                      </p>
                      <h2 className="sectionText--big textIsBold">
                        {adminStats?.declined_orders}
                      </h2>
                    </div>
                  </div>
                </div>

                <div className="col-md-4  col-6 mt-3">
                  <div className="hasBorder hasRadius center stats__card">
                    <div className="">
                      <p className="sectionText--small textIsGray mb-0">
                        Completed Orders
                      </p>
                      <h2 className="sectionText--big textIsBold">
                        {adminStats?.completed_orders}
                      </h2>
                    </div>
                  </div>
                </div>

                <div className="col-md-4  col-6 mt-3">
                  <div className="hasBorder hasRadius center stats__card">
                    <div className="">
                      <p className="sectionText--small textIsGray mb-0">
                        Total Payouts
                      </p>
                      <h2 className="sectionText--big  textIsBold">
                        {adminStats?.total_payment}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4"></div>
          </div>
        ) : (
          <Spinner big />
        )}
      </div>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  adminStats: state.admin.stats,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  fetchData: (token, success, filter) => dispatch(fetch_stats(token, success, filter)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
